/**
 * @ref https://www.npmjs.com/package/vue-json-csv
 */

import Vue from 'vue'
import JsonCSV from 'vue-json-csv'
Vue.component('downloadCsv', JsonCSV)